import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './seller-profile.css'

const SellerProfile = (props) => {
  return (
    <div className="seller-profile-container1">
      <Helmet>
        <title>Seller-Profile - BidWally</title>
        <meta
          property="og:title"
          content="Seller-Profile - BidWally"
        />
        <link
          rel="canonical"
          href="https://bidwally.com/seller-profile"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="profile-header">
        <div className="profile-header__container">
          <div className="profile-header__card">
            <div className="profile-header__media">
              <img
                src="https://images.pexels.com/photos/7534805/pexels-photo-7534805.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Satoshi_N"
                className="profile-header__avatar"
              />
              <div className="profile-header__badge-group">
                <div
                  title="Identity Verified"
                  className="profile-header__badge"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div className="profile-header__content">
              <div className="profile-header__identity">
                <h1 className="hero-title">Satoshi_N</h1>
                <div className="profile-header__location">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </g>
                  </svg>
                  <span className="section-content">Berlin, Germany</span>
                </div>
              </div>
              <div className="profile-header__stats">
                <div className="profile-header__stat-item">
                  <span className="profile-header__stat-value">99.8%</span>
                  <span className="profile-header__stat-label">
                    Reputation Score
                  </span>
                </div>
                <div className="profile-header__stat-divider"></div>
                <div className="profile-header__stat-item">
                  <span className="profile-header__stat-value">1,240</span>
                  <span className="profile-header__stat-label">
                    Successful Trades
                  </span>
                </div>
              </div>
              <div className="profile-header__actions">
                <button className="btn btn-primary btn-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"
                    ></path>
                  </svg>
                  <span>
                    {' '}
                    Message Seller
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </button>
                <button className="btn btn-lg btn-outline">Follow</button>
                <button className="profile-header__report btn btn-link btn-sm">
                  Report Profile
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="trust-panel">
        <div className="trust-panel__container">
          <h2 className="section-title">
            Seller Verification &amp; Trust Signals
          </h2>
          <div className="trust-panel__grid">
            <div className="trust-panel__card">
              <div className="trust-panel__icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Verified Identity</h3>
              <p className="section-content">
                Government-issued ID and biometric verification completed. Last
                re-verified: October 2025.
              </p>
              <div className="trust-panel__status trust-panel__status--success">
                <span>Active &amp; Confirmed</span>
              </div>
            </div>
            <div className="trust-panel__card">
              <div className="trust-panel__icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                  ></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Payment Integrity</h3>
              <p className="section-content">
                Linked non-custodial wallets show 0 flags and consistent volume
                across 3 major chains.
              </p>
              <div className="trust-panel__status trust-panel__status--success">
                <span>Low Risk Pattern</span>
              </div>
            </div>
            <div className="trust-panel__card">
              <div className="trust-panel__icon-box trust-panel__icon-box--warning">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m21.73 18l-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3M12 9v4m0 4h.01"
                  ></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Community Flags</h3>
              <p className="section-content">
                1 minor flag (3 months ago) regarding communication speed. No
                scams or fraud detected.
              </p>
              <div className="trust-panel__status trust-panel__status--warning">
                <span>1 Minor Dispute</span>
              </div>
            </div>
            <div className="trust-panel__card">
              <div className="trust-panel__icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092a10 10 0 1 0-4.777-4.719"
                  ></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Social Proof</h3>
              <p className="section-content">
                Verified phone, email, and Telegram. Member since 2022 with 100%
                response rate.
              </p>
              <div className="trust-panel__status trust-panel__status--success">
                <span>High Responsiveness</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="activity-feed">
        <div className="activity-feed__container">
          <h2 className="section-title">Seller Activity Timeline</h2>
          <div className="activity-feed__timeline">
            <div className="activity-feed__item">
              <div className="activity-feed__marker"></div>
              <div className="activity-feed__content">
                <span className="activity-feed__time">2 hours ago</span>
                <h3 className="section-subtitle">
                  Listing Posted: MacBook Pro M3 Max
                </h3>
                <p className="section-content">
                  Available for 0.08 BTC. Location: Berlin (Mitte). Map-verified
                  listing.
                </p>
              </div>
            </div>
            <div className="activity-feed__item">
              <div className="activity-feed__marker"></div>
              <div className="activity-feed__content">
                <span className="activity-feed__time">Yesterday</span>
                <h3 className="section-subtitle">
                  Successful Sale: Ledger Stax (New)
                </h3>
                <p className="section-content">
                  Transaction completed via BidWally P2P. Buyer left a 5-star
                  rating.
                </p>
              </div>
            </div>
            <div className="activity-feed__item">
              <div className="activity-feed__marker"></div>
              <div className="activity-feed__content">
                <span className="activity-feed__time">3 days ago</span>
                <h3 className="section-subtitle">
                  Price Updated: ETH Node Server
                </h3>
                <p className="section-content">
                  Discounted to 1.2 ETH. Active negotiation with 3 potential
                  buyers.
                </p>
              </div>
            </div>
            <div className="activity-feed__item">
              <div className="activity-feed__marker"></div>
              <div className="activity-feed__content">
                <span className="activity-feed__time">1 week ago</span>
                <h3 className="section-subtitle">Location Verified: Hamburg</h3>
                <p className="section-content">
                  Seller checked in from a verified local discovery point for a
                  physical trade.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="buyer-reviews">
        <div className="buyer-reviews__container">
          <div className="buyer-reviews__card">
            <div className="buyer-reviews__header">
              <div className="buyer-reviews__summary">
                <h2 className="section-title">Buyer Reviews</h2>
                <div className="buyer-reviews__rating-large">
                  <span className="buyer-reviews__score">4.9</span>
                  <div className="buyer-reviews__stars">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="var(--color-accent)"
                        stroke="var(--color-accent)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                      ></path>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="var(--color-accent)"
                        stroke="var(--color-accent)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                      ></path>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="var(--color-accent)"
                        stroke="var(--color-accent)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                      ></path>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="var(--color-accent)"
                        stroke="var(--color-accent)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                      ></path>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="var(--color-accent)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 18.338a2.1 2.1 0 0 0-.987.244L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16l2.309-4.679A.53.53 0 0 1 12 2"
                      ></path>
                    </svg>
                  </div>
                </div>
                <span className="section-content">
                  Based on 412 verified transactions
                </span>
              </div>
              <div className="buyer-reviews__filters">
                <button className="btn btn-outline btn-sm">Electronics</button>
                <button className="btn btn-outline btn-sm">
                  Digital Assets
                </button>
                <button className="btn btn-outline btn-sm">Services</button>
              </div>
            </div>
            <div className="buyer-reviews__list">
              <div className="buyer-reviews__item">
                <div className="buyer-reviews__meta">
                  <span className="buyer-reviews__author">CryptoWhale_88</span>
                  <span className="buyer-reviews__date">Oct 12, 2025</span>
                </div>
                <p className="section-content">
                  &quot;Super smooth transaction. We met in person at a Bitcoin
                  meetup. The hardware was exactly as described and he helped me
                  verify the signature. Highly recommend for high-value
                  trades.&quot;
                </p>
                <div className="buyer-reviews__tag">
                  <span>Verified Purchase: Trezor Safe 3</span>
                </div>
              </div>
              <div className="buyer-reviews__item">
                <div className="buyer-reviews__meta">
                  <span className="buyer-reviews__author">Alice_In_Web3</span>
                  <span className="buyer-reviews__date">Sep 28, 2025</span>
                </div>
                <p className="section-content">
                  &quot;Quick response and very patient with my questions about
                  the non-custodial transfer. 10/10 would buy from Satoshi_N
                  again.&quot;
                </p>
                <div className="buyer-reviews__tag">
                  <span>Verified Purchase: Software License</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="safety-features">
        <div className="safety-features__container">
          <div className="safety-features__card">
            <div className="safety-features__header">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="var(--color-accent)"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                ></path>
              </svg>
              <h2 className="section-title">Trade Safely with This Seller</h2>
            </div>
            <div className="safety-features__grid">
              <div className="safety-features__item">
                <h3 className="section-subtitle">Escrow Recommended</h3>
                <p className="section-content">
                  For digital goods, use BidWally&apos;s upcoming smart-contract
                  escrow. For now, prefer multi-sig wallets for large transfers.
                </p>
              </div>
              <div className="safety-features__item">
                <h3 className="section-subtitle">Public Meetups</h3>
                <p className="section-content">
                  This seller is active in the Berlin crypto community. We
                  suggest meeting at the &quot;Bitcoin Hub&quot; for physical
                  item handovers.
                </p>
              </div>
              <div className="safety-features__item">
                <h3 className="section-subtitle">No Off-Platform Links</h3>
                <p className="section-content">
                  Never click links leading to external payment gateways.
                  BidWally will never ask for your private keys or seed phrase.
                </p>
              </div>
            </div>
            <div className="safety-features__footer">
              <button className="btn btn-lg btn-secondary">
                Report Suspicious Activity
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="verification-audit">
        <div className="verification-audit__container">
          <h2 className="section-title">Verification History &amp; Audit</h2>
          <div className="verification-audit__timeline">
            <div className="verification-audit__step">
              <div className="verification-audit__icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="verification-audit__content">
                <h3 className="section-subtitle">Proof of Residency</h3>
                <p className="section-content">
                  Utility bill verified against Berlin municipal records. Valid
                  until Jan 2026.
                </p>
                <span className="verification-audit__date">
                  Completed: Jan 15, 2025
                </span>
              </div>
            </div>
            <div className="verification-audit__step">
              <div className="verification-audit__icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="verification-audit__content">
                <h3 className="section-subtitle">Biometric Identity</h3>
                <p className="section-content">
                  3D face scan matched with passport photo. Level 3 verification
                  achieved.
                </p>
                <span className="verification-audit__date">
                  Completed: Feb 02, 2025
                </span>
              </div>
            </div>
            <div className="verification-audit__step">
              <div className="verification-audit__icon verification-audit__icon--pending">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 18.338a2.1 2.1 0 0 0-.987.244L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16l2.309-4.679A.53.53 0 0 1 12 2"
                  ></path>
                </svg>
              </div>
              <div className="verification-audit__content">
                <h3 className="section-subtitle">Merchant Tier Upgrade</h3>
                <p className="section-content">
                  Currently processing high-volume seller status. Estimated
                  completion in 48h.
                </p>
                <span className="verification-audit__date">
                  Status: Pending Review
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-area">
        <div className="contact-area__container">
          <div className="contact-area__split">
            <div className="contact-area__info">
              <h2 className="section-title">Secure Communication</h2>
              <p className="section-content">
                Choose your preferred method to reach out. We recommend using
                our internal messaging for end-to-end encryption and dispute
                protection.
              </p>
              <ul className="contact-area__methods">
                <li className="contact-area__method">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092a10 10 0 1 0-4.777-4.719"
                    ></path>
                  </svg>
                  <span>BidWally Internal Chat (Encrypted)</span>
                </li>
                <li className="contact-area__method">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"
                    ></path>
                  </svg>
                  <span>Telegram (Verified: @SatoshiN_Berlin)</span>
                </li>
              </ul>
              <div className="contact-area__upsell">
                <h3 className="section-subtitle">Get Real-Time Updates</h3>
                <p className="section-content">
                  Subscribe to Satoshi_N&apos;s listings to get notified of new
                  crypto-priced deals before they hit the main feed.
                </p>
                <button className="btn btn-accent">Subscribe to Updates</button>
              </div>
            </div>
            <div className="contact-area__form-box">
              <form
                action="#"
                method="POST"
                data-form-id="e18a8290-5419-4f62-b088-ff700b661002"
                className="contact-area__form"
              >
                <div className="contact-area__form-group">
                  <label className="section-content">Your Message</label>
                  <textarea
                    required="true"
                    placeholder="Describe your interest in the listing..."
                    id="thq_textarea_jstS"
                    name="textarea"
                    data-form-field-id="thq_textarea_jstS"
                    className="contact-area__textarea"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  id="thq_button_BHlY"
                  name="button"
                  data-form-field-id="thq_button_BHlY"
                  className="btn btn-primary btn-xl"
                >
                  Send Secure Message
                </button>
                <p className="contact-area__warning">
                  By clicking send, you agree to BidWally&apos;s safety terms.
                </p>
                <button
                  type="button"
                  id="thq_button_cwXv"
                  name="button"
                  data-form-field-id="thq_button_cwXv"
                  className="contact-area__report-btn btn btn-link"
                >
                  Report suspicious behavior
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <div className="seller-profile-container2">
        <div className="seller-profile-container3">
          <Script
            html={`<script defer data-name="seller-profile-logic">
(function(){
  // Handle form submission UX enhancement
  const contactForm = document.querySelector('.contact-area__form');
  if (contactForm) {
    contactForm.addEventListener('submit', (e) => {
      // In a real app, we'd let the native action handle this or use fetch
      // For this demo, we provide visual feedback
      const submitBtn = contactForm.querySelector('button[type="submit"]');
      const originalText = submitBtn.textContent;
      
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';
      
      // Simulate network delay
      setTimeout(() => {
        submitBtn.style.backgroundColor = '#2ecc71';
        submitBtn.style.borderColor = '#2ecc71';
        submitBtn.textContent = 'Message Sent Successfully!';
        
        contactForm.reset();
        
        setTimeout(() => {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
          submitBtn.style.backgroundColor = '';
          submitBtn.style.borderColor = '';
        }, 3000);
      }, 1500);
    });
  }

  // Handle report buttons
  const reportButtons = document.querySelectorAll('.profile-header__report, .contact-area__report-btn');
  reportButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const confirmReport = confirm('Are you sure you want to report this seller? Our safety team will review the account activity.');
      if (confirmReport) {
        alert('Report submitted. Thank you for keeping BidWally safe.');
      }
    });
  });

  // Handle follow button toggle
  const followBtn = document.querySelector('.profile-header__actions .btn-outline');
  if (followBtn) {
    followBtn.addEventListener('click', () => {
      const isFollowing = followBtn.textContent === 'Following';
      if (isFollowing) {
        followBtn.textContent = 'Follow';
        followBtn.classList.remove('btn-primary');
        followBtn.classList.add('btn-outline');
      } else {
        followBtn.textContent = 'Following';
        followBtn.classList.remove('btn-outline');
        followBtn.classList.add('btn-primary');
      }
    });
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default SellerProfile
